export const CardCustomVariableElement =  ()=>{
    return (
        <div className="container">
            モンスター変数条件はMonsterVariableテーブルに含まれてないモンスターパラメータの条件を表します   
            以下の例ではcounterというパラメータが１以上のカードを表しています。（MonsterVariableに含まれていないパラメーターは初期は０で表されます)
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_card_custom_variable.png`}></img></p>
        </div>
    )
}
